<template>
    <div class="form-group col-md-6">
        <label for="inputs_postal_zip_code" class="mb-0"> {{ $t('postal_zip_code') }} </label>
        <app-input 
            id="inputs_postal_zip_code" 
            class="form-control" 
            type="text"
            v-model="selected" 
            :placeholder="$t('type_postal_zip_code')" />
    </div>
</template>

<script>
    export default {
        name: 'postalAddress',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>
